import { ColorModeProvider, useColorMode } from "@chakra-ui/color-mode";
import { css, normalizeBreakpoints } from "@chakra-ui/styled-system";
import { createContext, get, merge, runIfFn } from "@chakra-ui/utils";
import { Global, ThemeContext } from "@emotion/core";
import * as React from "react";
export function ThemeProvider(props) {
  var {
    children,
    theme
  } = props;
  var outerTheme = React.useContext(ThemeContext);
  var mergedTheme = merge({}, outerTheme, theme);
  mergedTheme.breakpoints = normalizeBreakpoints(mergedTheme.breakpoints);
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: mergedTheme
  }, children);
}
export function useTheme() {
  var theme = React.useContext(ThemeContext);

  if (!theme) {
    throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />`");
  }

  return theme;
}
export function ChakraProvider(props) {
  var _theme$config, _theme$config2;

  var {
    theme,
    children
  } = props;

  if (!theme) {
    throw Error("ChakraProvider: the `theme` prop is required");
  }

  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(ColorModeProvider, {
    defaultValue: theme == null ? void 0 : (_theme$config = theme.config) == null ? void 0 : _theme$config.initialColorMode,
    useSystemColorMode: theme == null ? void 0 : (_theme$config2 = theme.config) == null ? void 0 : _theme$config2.useInitialColorMode
  }, /*#__PURE__*/React.createElement(GlobalStyle, null), children));
}
var [StylesProvider, useStyles] = createContext({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
export { StylesProvider, useStyles };
export function GlobalStyle() {
  var {
    colorMode
  } = useColorMode();
  return /*#__PURE__*/React.createElement(Global, {
    styles: theme => {
      var styleObjectOrFn = get(theme, "styles.global");
      var bodyStyles = runIfFn(styleObjectOrFn, {
        theme,
        colorMode
      });
      if (!bodyStyles) return;
      var styles = css({
        body: bodyStyles
      })(theme);
      return styles;
    }
  });
}
//# sourceMappingURL=providers.js.map